// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ZoI8YCkg-MyOG4kwWyuQV {\n  display: inline-block;\n  background-color: var(--gray);\n  margin: calc(var(--space-small) / 2);\n  padding: calc(var(--space-small) / 2) var(--space-small);\n}\n", ""]);
// Exports
exports.locals = {
	"skill": "ZoI8YCkg-MyOG4kwWyuQV"
};
module.exports = exports;
